import { apiGet, apiPost, apiPut } from './client';

export type User = {
  id: string;
  email: string;
  fullName?: string | null;
  role: string;
};

export async function login(email: string, password: string) {
  return apiPost<{ user: User } | { error: string }, { email: string; password: string }>(
    '/auth/login',
    { email, password },
  );
}

export async function register(payload: { email: string; password: string; fullName?: string }) {
  return apiPost<{ userId: string }>('/auth/register', payload);
}

export async function logout() {
  return apiPost<{ message: string }>('/auth/logout');
}

export async function fetchCurrentUser() {
  return apiGet<{ user: User; expiresAt: number }>('/auth/me');
}

export async function updateProfile(payload: {
  fullName?: string;
  password?: string;
  newPassword?: string;
}) {
  return apiPut<{ message: string; user: User }>('/users/me', payload);
}
